import { Component } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/dropdowns/InlineDropdownWrapper.css'
import { IdValueEntity } from 'interfaces'
import InlineDropdownWrapper, { InlineDropdownCheckSelected } from 'components/atoms/dropdowns/InlineDropdownWrapper'
import { QAMarked } from 'interfaces/component'

type ListDropdownProps<TKey = string, TValue = string> = QAMarked & {
  entities: IdValueEntity<TKey, TValue>[]
  selected: IdValueEntity<TKey, TValue>
  className?: string
  captionClassName?: string
  withArrow?: boolean

  onSelect: (entity: IdValueEntity<TKey, TValue>) => void
}

export class ListDropdown<TKey = string, TValue = string> extends Component<ListDropdownProps<TKey, TValue>> {

  render () {
    const {
      selected,
      entities,
      qaMarker,
      className,
      withArrow,
      captionClassName,
    } = this.props

    const optionNodes = entities.map(({ id, value }) => (
      <div key={ String(id) } className={ cn(styles.option, { [styles.selectedOption]: id === selected.id }) }>
        <a className={ styles.optionCaption } data-option-id={ id }>{ value }</a>
      </div>
    ))

    const getCaption = (entity: IdValueEntity<TKey, TValue>): string => String(entity.value || '')

    return (
      <InlineDropdownWrapper
        selected={ selected }
        getCaption={ getCaption }
        checkSelected={ this.checkSelected }
        qaMarker={ qaMarker }
        onSelect={ this.props.onSelect }
        className={ className }
        captionClassName={ captionClassName }
        withArrow={ withArrow }
      >
        { optionNodes }
      </InlineDropdownWrapper>
    )
  }

  private checkSelected: InlineDropdownCheckSelected<IdValueEntity<TKey, TValue>> = (e) => {
    const { entities } = this.props
    const { target } = e
    const optionNode = (target as HTMLElement).closest(`[data-option-id]`) as HTMLElement | null
    if (!optionNode) {
      return null
    }

    const { optionId } = optionNode.dataset
    const selected = entities.find(({ id }) => String(id) === optionId)
    if (!selected) {
      return null
    }

    return selected
  }
}
